import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import PageTabs from '../../../components/PageTabs';
import {
  Package,
  Briefcase,
  ForkKnife as UtensilsCrossed,
  Grains as Wheat,
  Armchair,
  ArrowsLeftRight as ArrowLeftRight,
} from '@phosphor-icons/react';

const ProductsTab = ({ children, darkMode, ...props }) => {
  const { slug } = useParams();
  const { user } = useAuth();
  const isServicesType = ['SERVICES', 'SALON'].includes(user?.businessType);
  const isRestaurantType = ['FOOD_AND_BEVERAGE', 'RESTAURANT'].includes(user?.businessType);
  const isRetailType = !isServicesType && !isRestaurantType;

  const tabs = [
    {
      key: 'inventory',
      label: isServicesType ? 'Services' : isRestaurantType ? 'Menu' : 'Inventory',
      icon: isServicesType ? Briefcase : isRestaurantType ? UtensilsCrossed : Package,
      path: `/${slug}/owner/products`,
    },
    ...(isRestaurantType ? [
      { key: 'raw-materials', label: 'Raw Materials', icon: Wheat, path: `/${slug}/owner/products/raw-materials` },
      { key: 'tables', label: 'Tables', icon: Armchair, path: `/${slug}/owner/products/tables` },
    ] : []),
    ...(isRetailType ? [
      { key: 'transfers', label: 'Transfers', icon: ArrowLeftRight, path: `/${slug}/owner/products/transfers` },
    ] : []),
  ];

  return (
    <>
      <PageTabs tabs={tabs} darkMode={darkMode} />
      {children}
    </>
  );
};

export default ProductsTab;
